import React, { useState, useEffect } from "react"
import classes from "./Settings.module.css"
import EventReminders from "./EventReminders";
import Permissions from "./Permissions";
import AutoEmails from "./AutoEmails";
import AutoEmailsTrainer from "./AutoEmailsTrainer";
import GeneralSettings from "./GeneralSettings";
import PushNotifications from "./PushNotifications";
import WelcomeLinks from "./WelcomeLinks";
import AccountType from "./AccountType";
import InvoiceHistory from "./InvoiceHistory";
import ClientSettings from "./ClientSettings";
import GymResources from "./GymResources";
import TrainerPermissions from "./TrainerPermissions";
import Workouts from "./Workouts";
import { envAwarePost } from "../../util/util";
import ChainSettings from "./ChainSettings"
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button"
import { useDispatch, useSelector } from "react-redux";
import useCurrentUser from '../../hooks/useCurrentUser'
import {updateAppSettings} from './settingsSlice'

const AppSettings = ()=>{
    return null
}

function Settings() {
    const user = useCurrentUser()
    const [isLoading, setIsLoading] = useState(true)

    const [eventReminders, setEventReminders] = useState([])
    const [autoEmails, setAutoEmails] = useState([])
    const [autoEmailsTrainer, setAutoEmailsTrainer] = useState([])
    const [permissions, setPermissions] = useState([])
    const [notifications, setNotifications] = useState([])
    const [generalSettings, setGeneralSettings] = useState([])
    const [triggerReload, setTriggerReload] = useState(false)

    const [isEventReminderLoading, setIsEventReminderLoading] = useState(true)

    const accountType = useSelector(state => state.users.current_user.account_type)
    const gymId = useSelector(state => state.users.current_user.gym_id);

    const isClient = accountType === "client";
    // const isTrainer = accountType === "trainer";
    // const isGym = accountType === "gym";
    const isGym = (useSelector(state => state.users.current_user.gym)) === '1'
    const isTrainer = (((useSelector(state => state.users.current_user.trainer)) === '1') && !isGym)
    const isOwner = (
        (user.account_type === 'gym') ||
        (user.gym_id == 0 && user.account_type === 'trainer')
    )

    //24 hour time setting 
    const isTime24Hour = Number(useSelector(state => state.users.current_user.is_24_hour_time))


    function processEventReminders(event_reminders){
        let remindersEdited = {};
        Object.entries(event_reminders).forEach(([event, data]) => {
            let timeMode;
            let time = Number(data.time.split(":")[0]);

            if (!isTime24Hour) { 
                if (time >= 12) {
                    if (time == 12) {
                        timeMode = "PM"
                    } else {
                        time -= 12;
                        timeMode = "PM"
                    }

                } else if (time == 0) {
                    time = 12;
                    timeMode = "AM"
                } else {
                    timeMode = "AM"
                }
            }
            remindersEdited[event] = { enabled: data.enabled, event_type: data.event_type, time: time, timeMode: timeMode }
        })
        return remindersEdited;
    }

    useEffect(()=>{
        setIsEventReminderLoading(true)
        envAwarePost('api/init/api.php', {
            action: 'getInitData',
            platform: 'web'
        })
            .then((res) => {
                setIsEventReminderLoading(false)
                if (res.success == "1") {
                    let user = res.data.user;
                    
                    let remindersEdited = processEventReminders(user.event_reminders)
                    setEventReminders(remindersEdited);
                }})
    },[isTime24Hour])

    useEffect(() => {

        envAwarePost('api/init/api.php', {
            action: 'getInitData',
            platform: 'web'
        })
            .then((res) => {
                if (res.success == "1") {
                    let user = res.data.user;
                
                    setGeneralSettings({
                        accountType: user.account_type,
                        userID: user.user_id_number,
                        maxClients: res.data.usageData.clients.max,
                        measurementSystem: user.measurement_system,
                        gymId: user.gym_id,
                        isTime24Hour: user.is_24_hour_time
                    })

                    setPermissions(user.edit_permissions);

                    if (user.account_type === "trainer") {
                        setAutoEmails(user.automated_emails.client);
                        setAutoEmailsTrainer(user.automated_emails.trainer);
                    }

                    let notificationSettingsEdited = {};
                    Object.entries(user.notification_settings).forEach(([key, value]) => {
                        notificationSettingsEdited[key] = value.allow_emit
                    })

                    setNotifications(notificationSettingsEdited);
                    setIsLoading(false);
                }
            })
    }, [triggerReload])

    function handleCheckUpdate(name, currCheck, section, dbField) {

        if (currCheck === false) {
            currCheck = "0"
        } else {
            currCheck = "1"
        }

        if (section === "edit_permissions") {
            envAwarePost('/settingsMobWeb.php', {
                field: dbField,
                value: currCheck
            }).catch(err => console.log(err))

            setPermissions(prev => ({ ...prev, [name]: currCheck }))

        } else if (section === "automated_emails") {

            envAwarePost('settingsMobWeb.php', {
                field: dbField,
                value: currCheck
            }).catch(err => console.log(err))


        } else if (section === "updateNotificationSetting") {

            envAwarePost('api/user/api.php', {
                action: section,
                type: dbField,
                allow_emit: currCheck
            }).catch(err => console.log(err))

            setNotifications(prev => ({ ...prev, [name]: currCheck }))

        }
    }

    function renderGymAccount() {

        // if (generalSettings.accountType === "gym") {
        if (isGym) {
            return (
                <>
                    {/*   GYM WIDE SETTINGS   */}
                    <GymResources/>
                    {/*   PUSH NOTIFICATION SETTINGS   */}
                    <PushNotifications notifications={notifications} handleCheckUpdate={handleCheckUpdate} />
                    <AutoEmails autoEmails={autoEmails} setAutoEmails={setAutoEmails} handleCheckUpdate={handleCheckUpdate} />

                    {/*   WELCOME LINKS   */}
                    <WelcomeLinks />

                    {/*   EVENT REMINDERS   */}
                    <EventReminders 
                        eventReminders={eventReminders} 
                        setEventReminders={setEventReminders} 
                        setTriggerReload={setTriggerReload} 
                        isEventReminderLoading={isEventReminderLoading}
                        />
                    {/*   PERMISSIONS   */}
                  <Permissions permissions={permissions} handleCheckUpdate={handleCheckUpdate} shared />
                  <TrainerPermissions/>
                </>
            )
        }
    }

    function renderTrainerAccount() {
        return (
            <>
                {/*   EVENT REMINDERS   */}
                {generalSettings.gymId == 0 && 
                    <EventReminders
                        eventReminders={eventReminders} 
                        setEventReminders={setEventReminders} 
                        isEventReminderLoading={isEventReminderLoading}
                    />
                }

                {/*   PERMISSIONS   */}
                <Permissions permissions={permissions} handleCheckUpdate={handleCheckUpdate} />

                {/*   CLIENT EMAIL SETTINGS   */}
                <AutoEmails autoEmails={autoEmails} setAutoEmails={setAutoEmails} handleCheckUpdate={handleCheckUpdate} />

                {/*   PUSH NOTIFICATION SETTINGS   */}
                <PushNotifications notifications={notifications} handleCheckUpdate={handleCheckUpdate} />

                {/*   WELCOME LINKS   */}
                {generalSettings.gymId == 0 && <WelcomeLinks />}

                {/*   TRAINER AUTOMATED LINKS   */}
                <AutoEmailsTrainer autoEmailsTrainer={autoEmailsTrainer} setAutoEmailsTrainer={setAutoEmailsTrainer} handleCheckUpdate={handleCheckUpdate} />

                {/* COPY EXERCISE NOTES  */}
                <Workouts/>

                {/* ACCOUNT TYPE */}
                <AccountType trainerCode={generalSettings.userID} />
            </>
        )

    }

    return (
            <div className="pt-2 px-2 px-md-3">
                <strong className="d-block mb-2 text-center"> 
                    Settings 
                </strong>

            {isClient && <ClientSettings />}


            {generalSettings.accountType === "chain" && <ChainSettings />}


            {(isTrainer || isGym) ? !isLoading ?
                <>
                    <form className="form-horizontal d-flex flex-column align-items-center">

                        {/*   GENERAL SETTINGS   */}
                        <GeneralSettings 
                            generalSettings={generalSettings} 
                            setGeneralSettings={setGeneralSettings} 
                            setTriggerReload={setTriggerReload}
                        />
                        {/*   InvoiceHistory   */}
                        {isOwner&&<InvoiceHistory/>}
                        {isOwner&&<AppSettings/>}
                        {/*   GYM FORMS   */}
                        {isGym && renderGymAccount()}

                        {/*   TRAINER FORMS   */}
                        {isTrainer && renderTrainerAccount()}
                    </form>

                    {/* <Button onClick={() => alert("No need to save.  Data is automatically saved as it is entered but we added this button so users do not worry about losing their work.")} variant="primary float-right my-2" >
                        Data is Automatically Saved
                    </Button> */}
                    <div style={{margin:"20px", float:"right"}}>
                        <i className="fas fa-info-circle"></i> Data is Automatically Saved
                    </div>

                </> :
                <div
                    style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%,-50%)",
                        textAlign: "center",
                    }}
                >
                    <Spinner animation="border" role="status" variant="primary">
                        <span className="sr-only">Loading...</span>
                    </Spinner> </div>

                : null}
        </div>
    )
}

export default Settings